
import { computed, defineComponent } from 'vue';
import BaseTicker from '@/components/BaseTicker.vue';
import { useCurrenciesTicker } from '@/composables/useCurrenciesTicker';
export default defineComponent({
  components: {
    BaseTicker,
  },
  setup() {
    const { currenciesTicker } = useCurrenciesTicker();

    const currenciesArray = computed(() => {
      const temp = [];
      for (const currency in currenciesTicker.value) {
        temp.push({ ...currenciesTicker.value[currency], id: currency });
      }
      return temp.length == 0 ? null : temp;
    });

    function getSVG(name: string) {
      return `${require('@/assets/sprite.svg')}#${name}`;
    }

    return { currenciesArray, getSVG };
  },
});
